export enum AuthorityType {
    CASE = 'CASE',
    TRIAGE = 'TRIAGE',
    NONE = 'NONE',
}
